/**
 * @generated SignedSource<<f97ab00b839aca7bbe5d395f396bb629>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoEditMainProducts_TodoWorkspace$data = {
  readonly id: string;
  readonly linkedProducts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"LinkedWorkspaceProductItem_WorkspaceProduct">;
  }>;
  readonly " $fragmentType": "WorkspaceTodoEditMainProducts_TodoWorkspace";
};
export type WorkspaceTodoEditMainProducts_TodoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoEditMainProducts_TodoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainProducts_TodoWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoEditMainProducts_TodoWorkspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkspaceProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedWorkspaceProductItem_WorkspaceProduct"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "5198530d56aff5d3a3380193c4551ad8";

export default node;
